export default {
    wizardType: "COSMOS",

    getJDBCURL: (m) => m.get("serviceEndpoint"),

    getConnectionParams: (type, model) => ({
        UserName: null,
        Password: model.get("accessKey"),
        ConnectionURL: model.getJDBCURL(),
    }),
};

